export default function KPICard({ title, value, change, changeType = "neutral", icon: Icon, onClick }) {
  return (
    <div
      onClick={onClick}
      className={`bg-white rounded-lg border border-gray-200 p-4 sm:p-6 ${onClick ? "cursor-pointer hover:border-[#367588] hover:shadow-md transition-all" : ""}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-xs sm:text-sm text-gray-500 mb-1 truncate">{title}</p>
          <p className="text-2xl sm:text-3xl font-semibold text-gray-900">{value}</p>
          {change && (
            <p className={`text-xs sm:text-sm mt-2 ${changeType === "positive" ? "text-green-600" : changeType === "negative" ? "text-red-600" : "text-gray-500"}`}>
              {change}
            </p>
          )}
        </div>
        <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-[#367588]/10 flex items-center justify-center flex-shrink-0 ml-3">
          <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-[#367588]" />
        </div>
      </div>
    </div>
  );
}
